<template>
  <div class="SuccessfulCase" v-loading="loading">
    <!-- 成功案例 -->
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>成功案例</li>
        <li>不断提升自身技术及用户体验</li>
        <li></li>
      </ul>
    </div>
    <div class="breadcrumb">
      <div class="breadcrumbBox">
        <img src="@/assets/img/spzx/cpzx_home.png" alt="" />
        <div class="breadcrumbBox_text">
          <span>首页&nbsp;></span>
          <span>成功案例</span>
          <span v-if="currentCategoryName">&nbsp;>&nbsp;{{ currentCategoryName }}</span>
        </div>
      </div>
    </div>
    <div class="Solution_box" id="main-content">
      <div class="contentBox">
        <div class="itemBox">
          <div
            class="item"
            v-for="(item, index) in arr"
            :key="index"
            @click="goPage(item)"
          >
            <img :src="item.imgUrl" alt="" />
            <ul class="itemText">
              <li>{{ item.name }}</li>
              <li>{{ item.introduction }}</li>
            </ul>
          </div>
        </div>
        <el-pagination
          class="page"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="[6, 12, 18, 36]"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ArticleCenter from '@/api/articleCenter.js'
import { getSuccessfulCategories } from '@/utils/successfulCategoryStore.js'

export default {
  name: 'SuccessfulCase',
  data () {
    return {
      arr: [],
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      categoryId: '',              // 当前分类ID（仅用于映射名称，不用于请求）
      classifyList: [],            // 分类列表（用于名称映射）
      currentCategoryName: ''      // 当前分类名称（用于面包屑和请求参数）
    }
  },
  methods: {
    // 获取分类列表（用于名称映射）
    async getClassifyList () {
      try {
        const categories = await getSuccessfulCategories()
        this.classifyList = categories
      } catch (error) {
        console.error('获取成功案例分类失败', error)
      }
    },

    // 根据分类ID获取名称
    getCategoryNameById (id) {
      if (!id) return ''
      const found = this.classifyList.find(item => item.id.toString() === id.toString())
      return found ? found.name : ''
    },

    // 加载数据：根据路由参数或默认第一个分类
    async loadDataFromRoute () {
      await this.getClassifyList()
      let categoryId = this.$route.query.categoryId
      // 如果没有参数且分类列表不为空，使用第一个分类
      if (!categoryId && this.classifyList.length > 0) {
        categoryId = this.classifyList[0].id
      }
      this.categoryId = categoryId ? categoryId.toString() : ''
      this.currentCategoryName = this.getCategoryNameById(this.categoryId)
      this.page = 1
      this.getList()
    },

    goPage (item) {
      if (item && item.id) {
        this.$router.push({
          name: 'SuccessfulCaseDetails',
          query: {
            articleCenterId: item.id.toString()
          }
        })
      } else {
        this.$message.error('案例数据异常，无法查看详情')
      }
    },

    async getList () {
      this.loading = true
      const params = {
        name: '',
        startTime: '',
        endTime: '',
        page: this.page,
        pageSize: this.pageSize,
        successfulType: this.categoryId || '',   // 改为传ID
        articleType: 3
      }
      try {
        const { code, msg, data, total } = await ArticleCenter.queryAcList(params)
        if (code === 200) {
          this.arr = (data || []).filter(item => item.startStatus === 1)
          this.total = total
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        this.$message.error('获取成功案例列表失败')
      } finally {
        this.loading = false
      }
    },

    // 改变页码
    handleCurrentChange (page) {
      this.page = page
      this.getList()
    },

    // 改变条数
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.page = 1
      this.getList()
    }
  },
  mounted () {
    this.loadDataFromRoute()
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'SuccessfulCase') {
        this.loadDataFromRoute()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.SuccessfulCase {
  width: 100%;
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }

        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }
  .breadcrumb {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;

    .breadcrumbBox {
      width: 1206px;
      height: 48px;
      font-family: Source Han Sans CN;
      display: flex;
      align-items: center;
      position: relative;

      img {
        width: 22px;
        height: 20px;
      }

      .breadcrumbBox_text {
        position: absolute;
        top: 17px;
        left: 40px;
      }

      span {
        font-size: 16px;

        &:nth-child(1) {
          color: #666666;
        }

        &:nth-child(2) {
          color: #2b8737;
        }

        &:nth-child(3) {
          color: #2b8737;
        }
      }
    }
  }
  .Solution_box {
    width: 100%;
    background-color: #f5f5f5;
    padding: 0 0 36px 0;
    display: flex;
    justify-content: center;
    .contentBox {
      width: 1206px;
      .itemBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .item {
          width: 390px;
          height: 344px;
          margin-top: 36px;
          margin-left: 8px;
          img {
            width: 100%;
            height: 235px;
          }
          .itemText {
            width: 100%;
            height: 108px;
            background-color: #fff;
            padding: 0 20px;
            li {
              &:nth-child(1) {
                width: 100%;
                height: 20px;
                text-align: center;
                padding-top: 18px;
                font-weight: bold;
                font-size: 16px;
                color: #333333;
              }
              &:nth-child(2) {
                width: 100%;
                height: 56px;
                font-size: 14px;
                line-height: 18px;
                margin-top: 28px;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
              }
            }
          }
          &:hover {
            cursor: pointer;
            opacity: 0.7;
          }
        }
      }
    }
  }
}
.page {
  width: 100%;
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>

<style>
/* 分页组件全局样式 */
.SuccessfulCase .page .el-pagination.is-background .el-pager li:not(.disabled):hover {
  background-color: #1c7e28 !important;
}

.SuccessfulCase .page .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1c7e28 !important;
}

.SuccessfulCase .page .el-pagination__jump .el-input__inner:focus {
  border-color: #1c7e28 !important;
}

.SuccessfulCase .page .el-select .el-input.is-focus .el-input__inner {
  border-color: #1c7e28 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/successfulCase/SuccessfulCase.vue